export const WIDGET_EMBEDDABLE_PATH = '/widget/embeddable_items'
export const WIDGET_EMBEDDABLE_ITEMS_PATH = `${WIDGET_EMBEDDABLE_PATH}/:token`
